<template>
  <th
    class="border-neutral-light-5 bg-neutral-light-5 text-neutral-dark-5 p-2 text-xs font-normal"
  >
    <slot />
  </th>
</template>
